module.exports = __webpack_public_path__ + "static/media/4021.cda31df9.jpg";